"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.repaymentInsightsAccumulator = exports.profitInsightsAccumulator = void 0;
const commonUtils = __importStar(require("../../utils"));
// !TODO: @eldarshamukhamedov Move to dashboard
const profitInsightsAccumulator = (inputs) => {
    const { cohortTruncatedBaseDate, cohortTruncatedSeriesDate, cohortSeriesAge, } = inputs[0];
    let aggregateTotalVintageCalcValue = 0;
    let aggregateChargedOffVintageCalcValue = 0;
    let aggregateDelinquentVintageCalcValue = 0;
    for (const input of inputs) {
        aggregateTotalVintageCalcValue += input.totalVintageCalcValue;
        aggregateChargedOffVintageCalcValue +=
            input.totalNormalizedIsChargedOffVintageCalcValue;
        aggregateDelinquentVintageCalcValue +=
            input.totalNormalizedIsDelinquentVintageCalcValue;
    }
    return {
        cohortTruncatedBaseDate,
        cohortTruncatedSeriesDate,
        cohortSeriesAge,
        totalVintageCalcValue: aggregateTotalVintageCalcValue,
        totalNormalizedIsChargedOffVintageCalcValue: aggregateChargedOffVintageCalcValue,
        totalNormalizedIsDelinquentVintageCalcValue: aggregateDelinquentVintageCalcValue,
        chargedOffPercentageOfTotalVintageCalcValue: commonUtils.divideByOrZero(aggregateChargedOffVintageCalcValue, aggregateTotalVintageCalcValue),
        delinquentPercentageOfTotalVintageCalcValue: commonUtils.divideByOrZero(aggregateDelinquentVintageCalcValue, aggregateTotalVintageCalcValue),
    };
};
exports.profitInsightsAccumulator = profitInsightsAccumulator;
// !TODO: @eldarshamukhamedov Move to dashboard
const repaymentInsightsAccumulator = (inputs) => {
    const { cohortTruncatedBaseDate, cohortTruncatedSeriesDate, cohortSeriesAge, } = inputs[0];
    let aggregateTotalRepayments = 0;
    let aggregateReceivableCount = 0;
    let aggregateTotalInitialBalance = null;
    let currentBaseDate = null;
    let currentCumulativeRepayments = 0;
    for (const input of inputs) {
        if (!currentBaseDate || currentBaseDate !== input.cohortBaseDate) {
            aggregateTotalRepayments += currentCumulativeRepayments;
            currentBaseDate = input.cohortBaseDate;
            aggregateReceivableCount += input.originatedReceivablesCount;
            if (input.totalInitialBalanceOfOriginatedReceivables) {
                if (aggregateTotalInitialBalance) {
                    aggregateTotalInitialBalance +=
                        input.totalInitialBalanceOfOriginatedReceivables;
                }
                else {
                    aggregateTotalInitialBalance =
                        input.totalInitialBalanceOfOriginatedReceivables;
                }
            }
        }
        currentCumulativeRepayments = input.cumulativeRepayments;
    }
    aggregateTotalRepayments += currentCumulativeRepayments;
    return {
        cohortTruncatedBaseDate,
        cohortTruncatedSeriesDate,
        cohortSeriesAge,
        totalRepayments: aggregateTotalRepayments,
        averageRepaymentPerReceivable: commonUtils.divideByOrZero(aggregateTotalRepayments, aggregateReceivableCount),
        percentageRepaidOfTotalInitialBalance: aggregateTotalInitialBalance
            ? commonUtils.divideByOrZero(aggregateTotalRepayments, aggregateTotalInitialBalance)
            : undefined,
        aggregateReceivableCount,
    };
};
exports.repaymentInsightsAccumulator = repaymentInsightsAccumulator;
//# sourceMappingURL=accumulatorFn.js.map